/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReactionRequest
 */
export interface CreateReactionRequest {
    /**
     * Type of entity to react to
     * @type {string}
     * @memberof CreateReactionRequest
     */
    reactableType: CreateReactionRequestReactableTypeEnum;
    /**
     * ID of the entity to react to
     * @type {string}
     * @memberof CreateReactionRequest
     */
    reactableId: string;
    /**
     * Type of reaction (like or dislike)
     * @type {string}
     * @memberof CreateReactionRequest
     */
    reactionType: CreateReactionRequestReactionTypeEnum;
}


/**
 * @export
 */
export const CreateReactionRequestReactableTypeEnum = {
    Itinerary: 'itinerary',
    Post: 'post',
    Stop: 'stop'
} as const;
export type CreateReactionRequestReactableTypeEnum = typeof CreateReactionRequestReactableTypeEnum[keyof typeof CreateReactionRequestReactableTypeEnum];

/**
 * @export
 */
export const CreateReactionRequestReactionTypeEnum = {
    Like: 'like',
    Dislike: 'dislike'
} as const;
export type CreateReactionRequestReactionTypeEnum = typeof CreateReactionRequestReactionTypeEnum[keyof typeof CreateReactionRequestReactionTypeEnum];


/**
 * Check if a given object implements the CreateReactionRequest interface.
 */
export function instanceOfCreateReactionRequest(value: object): value is CreateReactionRequest {
    if (!('reactableType' in value) || value['reactableType'] === undefined) return false;
    if (!('reactableId' in value) || value['reactableId'] === undefined) return false;
    if (!('reactionType' in value) || value['reactionType'] === undefined) return false;
    return true;
}

export function CreateReactionRequestFromJSON(json: any): CreateReactionRequest {
    return CreateReactionRequestFromJSONTyped(json, false);
}

export function CreateReactionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReactionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reactableType': json['reactableType'],
        'reactableId': json['reactableId'],
        'reactionType': json['reactionType'],
    };
}

  export function CreateReactionRequestToJSON(json: any): CreateReactionRequest {
      return CreateReactionRequestToJSONTyped(json, false);
  }

  export function CreateReactionRequestToJSONTyped(value?: CreateReactionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reactableType': value['reactableType'],
        'reactableId': value['reactableId'],
        'reactionType': value['reactionType'],
    };
}

